import { useState } from "react";
import { Link } from "react-router-dom";

const WP_API = "/api/wp/wp-json";
const RED    = '#DC143C';
const DARK   = '#0a0404';
const BORDER = 'rgba(255,255,255,0.1)';
const MUTED  = 'rgba(255,255,255,0.35)';
const WHITE  = '#ffffff';

export default function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [sent, setSent]   = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const res = await fetch(`${WP_API}/rr/v1/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Erro ao enviar email");
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: DARK, padding: "40px 24px",
    }}>
      <div style={{ width: "100%", maxWidth: 420 }}>

        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 9, fontWeight: 700, color: RED, letterSpacing: "0.25em", textTransform: "uppercase", marginBottom: 14 }}>RR Magma</div>
          <div style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 24, fontWeight: 900, color: WHITE }}>Esqueceu sua senha?</div>
        </div>

        {sent ? (
          <div style={{ background: "rgba(34,197,94,0.08)", border: "1px solid rgba(34,197,94,0.2)", borderRadius: 8, padding: "28px", textAlign: "center" }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>✉️</div>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: "#22c55e", fontWeight: 700, letterSpacing: "0.1em", marginBottom: 10 }}>EMAIL ENVIADO</div>
            <p style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 13, color: "rgba(255,255,255,0.6)", lineHeight: 1.7 }}>
              Se este email existir na nossa base, você receberá um link de redefinição em breve. Verifique sua caixa de spam.
            </p>
            <Link to="/entrar" style={{ display: "inline-block", marginTop: 16, fontFamily: "'IBM Plex Mono', monospace", fontSize: 10, fontWeight: 700, color: RED, letterSpacing: "0.08em", textDecoration: "none" }}>← Voltar ao login</Link>
          </div>
        ) : (
          <>
            <p style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 13, color: MUTED, lineHeight: 1.7, marginBottom: 24, textAlign: "center" }}>
              Digite seu email e enviaremos um link para redefinir sua senha.
            </p>

            {error && (
              <div style={{ background: "rgba(220,20,60,0.1)", border: "1px solid rgba(220,20,60,0.3)", borderRadius: 6, padding: "12px 16px", marginBottom: 16, fontFamily: "'IBM Plex Mono', monospace", fontSize: 12, color: "#ff6b6b" }}>{error}</div>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div>
                <label style={{ display: "block", marginBottom: 6, fontFamily: "'IBM Plex Mono', monospace", fontSize: 10, color: MUTED, letterSpacing: "0.12em", textTransform: "uppercase" }}>E-mail</label>
                <input
                  type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                  placeholder="seu@email.com"
                  style={{ width: "100%", padding: "12px 14px", boxSizing: "border-box", border: `1px solid ${BORDER}`, borderRadius: 6, fontFamily: "'IBM Plex Mono', monospace", fontSize: 13, color: WHITE, background: "rgba(255,255,255,0.04)", outline: "none" }}
                />
              </div>
              <button
                onClick={handleSubmit}
                disabled={busy || !email}
                style={{ width: "100%", padding: "14px", background: busy || !email ? "rgba(255,255,255,0.1)" : RED, color: WHITE, border: "none", borderRadius: 6, fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, fontWeight: 800, letterSpacing: "0.1em", textTransform: "uppercase", cursor: busy || !email ? "not-allowed" : "pointer" }}
              >{busy ? "Enviando..." : "Enviar link de redefinição"}</button>
            </div>

            <div style={{ marginTop: 20, textAlign: "center" }}>
              <Link to="/entrar" style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: MUTED, textDecoration: "none" }}>← Voltar ao login</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
